import React from 'react';
import { translate } from 'react-i18next';
import { Grid, Typography } from 'material-ui';
import PopUpInfoDialog from './PopUpInfoDialog';
import { globalPopUpWidget } from './PopUpDialogController';
import { getAccountName } from '../components/Utils/UserFunctions';
class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.accountName = getAccountName();

        let ci = this.accountName === 'b2bwebdawson' 
            ? props.t('CONTACT_INFO_DAWSON', { returnObjects: true }) : props.t('CONTACT_INFO', { returnObjects: true });
        let shouldDisplayPopUp = ci && ci.length >= 1;
        this.state = {
            dialogOpen: false,
            contactOptions: ci,
            shouldDisplayPopUp: shouldDisplayPopUp
        };
    }
    handleCloseDialog = value => {
        //si tengo value el usuario apreto confirmar
        this.setState({ dialogOpen: false });
    };

    handleOpenDialog = value => {
        //si tengo value el usuario apreto confirmar
        this.setState({ dialogOpen: true });
    }

    displayContentPopUp = value => {
        if (this.accountName === 'b2bwebolympia') {
            return;
        }
        if (this.state.shouldDisplayPopUp) {
            globalPopUpWidget('cmsPopUpInfoDialog', {
                contactOptions: this.state.contactOptions,
                title: this.props.t('CONTACT_INFO_TITLE')
            });
        }
    };
    render() {
        const { t } = this.props;
        const accountName = getAccountName().toLowerCase();
        const currentYear = new Date().getFullYear();
        return <div style={{ padding: 8 }}>
            <PopUpInfoDialog
                open={this.state.dialogOpen}
                onOpen={this.handleOpenDialog}
                onClose={this.handleCloseDialog}
            />
            <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <Grid item>
                    <Typography onClick={e => { this.displayContentPopUp(); }} variant="title">
                        <span style={{ color: 'var(--error-color, red)' }}>{t('CONTACT_INFO_TITLE')}</span>&nbsp;                      
                    </Typography>
                    {
                        this.accountName === 'b2bwebolympia' && this.accountName !== 'b2bwebdawson' && <Typography variant="title" style={{textTransform: 'lowercase'}}>{t('CONTACT_INFO_PHONE') + ' · ' + t('CONTACT_INFO_EMAIL')}</Typography>                        
                    }
                    {
                        this.accountName !== 'b2bwebdawson' && this.accountName !== 'b2bwebolympia' && <Typography variant="title">{t('CONTACT_INFO_PHONE')}</Typography>}
                    {
                        this.accountName !== 'b2bwebdawson' && 
                        <div>
                        <Typography variant="body2" style={{fontWeight: 'normal', letterSpacing: 'normal'}}  >{t('CONTACT_INFO_HOURS')}</Typography>
                        <Typography variant="body2" style={{fontWeight: 'normal', letterSpacing: 'normal'}}  >{t('CONTACT_INFO_HOURS_WEEKEND')}</Typography>
                        </div>
                    }                     
                </Grid>
                {this.accountName !== 'b2bwebdawson' && <Grid item>
                    <img src={'assets/' + accountName + '/logo-footer.png'} alt="logo" />
                </Grid>}
            </Grid>
            <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <Grid item xs={2}>
                    <Typography variant="body2">&reg;{currentYear} Viajes Olympia</Typography>
                </Grid>
                {/* <Grid item xs={2}>
                    <Typography variant="body2"><a href="#/conditions">Condiciones Generales</a></Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="body2"><a href="#/privacy">Politicas de privacidad</a></Typography>
                </Grid> */}
                <Grid item xs={5}>

                </Grid>
                <Grid item xs={1}>
                    <Typography variant="body2">{process.env.REACT_APP_BUILD_VERSION}</Typography>
                </Grid>
            </Grid>
        </div>;
    }
}
export default translate('translations')(Footer);


// WEBPACK FOOTER //
// ./src/cms/Footer.js